// Auto-generated by scripts/generateLastModified.js
// Do not edit manually - this file is regenerated at build time

const lastModified = {
  "Home": "2026-02-15T19:38:33.000Z",
  "Contact": "2026-02-15T19:38:33.000Z",
  "ReadingList": "2026-02-15T19:38:33.000Z",
  "FlightStatus": "2026-02-15T19:38:33.000Z",
  "FlightPlanner": "2026-02-15T20:07:50.000Z"
};

export function getLastModified(componentName) {
  const isoDate = lastModified[componentName];
  if (!isoDate) return null;
  
  return new Date(isoDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export default lastModified;
